import { useMutation, useQuery } from '@tanstack/react-query';
import {
  CreateSubscriptionRequest,
  subscriptionplanService,
} from '../services/razorpaySubscription-service';

export const useCreateSubscription = () => {
  return useMutation<any, Error, CreateSubscriptionRequest>({
    mutationFn: subscriptionplanService.createSubscription,
  });
};

export const useGetActiveSubscription = () => {
  return useQuery({
    queryKey: ['active-subscription'],
    queryFn: subscriptionplanService.getActiveSubscriptionProfiles,
    enabled: true,
    staleTime: 30 * 1000,
    refetchOnWindowFocus: true,
  });
};

/**
 * Prices the selected plan, applying a coupon if one is given.
 *
 * Not retried. A quote is priced from the plan and the coupon, so a failure is
 * a rejected request rather than a flaky one, and retrying only delays the
 * fallback to the plain purchase path.
 */
export const useCheckoutQuote = (
  planId: number | null,
  couponCode?: string
) => {
  return useQuery({
    queryKey: ['checkout-quote', planId, couponCode],
    queryFn: () => subscriptionplanService.getQuote(planId!, couponCode),
    enabled: !!planId,
    retry: false,
  });
};
